export const INITIAL_HEIGHT = 200;
export const MIN_HEIGHT = 150;
export const MAX_HEIGHT = 500;
export const MAX_WIDTH = 600;
export const MAX_WIDTH_OFFSET = 50;
export const BOTTOM_BAR_HEIGHT = 30;

export const PREVIEW_LENGTH = 200;
export const PREVIEW_LENGTH_OFFSET = 100;
export const SCROLL_FADE_LENGTH = 40;
